export default "__VITE_PUBLIC_ASSET__0723cc5f__"